module.exports = __webpack_public_path__ + "img/delect.39d128fa.png";